import { useHistory } from 'react-router';

import { useEvent } from '@legacy-providers/event';

import { Form, useForm } from '@shared/forms/components/Form';
import { TextField } from '@shared/forms/components/TextField';
import {
  CreateTimeTrackingGroupData,
  createTimeTrackingGroup,
} from '@shared/time-tracking-groups/endpoints/createTimeTrackingGroup';
import { Portlet } from '@shared/ui/components/Portlet';

import { AdminWrapper } from '@admin/layout/components/AdminWrapper';
import RegistrationMultiSelectField from '@admin/time-tracking-groups/components/RegistrationMultiSelectField/RegistrationMultiSelectField';

type TimeTrackingGroupData = App.Domain.TimeTracking.Data.TimeTrackingGroupData;

export function CreateTimeTrackingGroup() {
  const { push } = useHistory();
  const event = useEvent();

  const { form, fields } = useForm<CreateTimeTrackingGroupData>({
    defaults: {
      eventId: event.id,
      registrationIds: [],
    },
  });

  return (
    <AdminWrapper
      title="Create Time Tracking Group"
      breadcrumb={{ label: 'Venues', url: '/admin/time-tracking-groups' }}
    >
      <Portlet>
        <Form
          action={createTimeTrackingGroup}
          onSave={(timeTrackingGroup: TimeTrackingGroupData) =>
            push(`/admin/time-tracking-groups/${timeTrackingGroup.id}/edit`)
          }
          onSaveAndReturn={() => push('/admin/time-tracking-groups')}
          onCancel={() => push('/admin/time-tracking-groups')}
          form={form}
        >
          <TextField name={fields.name} label="Name" />
          <RegistrationMultiSelectField name="registrationIds" label="Registrations" />
        </Form>
      </Portlet>
    </AdminWrapper>
  );
}
